import React from "react";
import usePageTitle from "./use-page-title";
import {useEnvValue} from "@morningtrain/react-helpers";

function useFullPageTitle() {

    const baseTitle = usePageTitle();
    const [titleSuffix] = useEnvValue('app.name');

    function getFullTitle() {
        return [baseTitle, titleSuffix].filter(t => t).join(' | ');
    }

    const [title, setTitle] = React.useState(getFullTitle());

    React.useEffect(() => {
        const fullTitle = getFullTitle();

        if(fullTitle !== title) {
            setTitle(fullTitle);
        }

    }, [baseTitle, titleSuffix]);
    
    return title;
}

export default useFullPageTitle;
